// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__CZdmb","card":"styles_card__47d3j","imgContainer":"styles_imgContainer__9YipB","textCard":"styles_textCard__0X2X6"};